import './style/index.js';

import _Comment from './Comment';

export type { CommentProps } from './Comment';
export * from './type';

export const Comment = _Comment;

export default Comment;
